import { useBreakpointValue } from "@chakra-ui/react";
import { useEffect, useState } from "react";

interface IUseSideBar {
    isSideBarOpen: boolean,
    openSideBar: () => void,
    closeSideBar: () => void
}

export const useSideBar = (): IUseSideBar => {
    const [isSideBarOpen, setIsSideBarOpen] = useState<boolean>(false)
    const isMobile = useBreakpointValue<boolean>({ base: true, md: false });

    const openSideBar = () => setIsSideBarOpen(true);
    const closeSideBar = () => setIsSideBarOpen(false);

    useEffect(() => {
        if (isMobile) {
            closeSideBar()
        } else {
            openSideBar()
        }
    }, [isMobile])

    return { isSideBarOpen, openSideBar, closeSideBar }
}